import './index.css'
import React from 'react'

const RadioButton = ({ className, id, value, selectedVaule, onClick, label, ...rest }) => {
  return (
    <div className="radio-wrapper" {...rest}>
      <input
        type="radio"
        id={id}
        name={'name_' + value}
        value={value}
        onChange={onClick}
        checked={value === selectedVaule}
      />
      {!!label && <label htmlFor={id}>{label}</label>}
    </div>
  )
}

export default RadioButton
